import { render, staticRenderFns } from "./CustomerProviders.vue?vue&type=template&id=727151f6&scoped=true"
import script from "./CustomerProviders.vue?vue&type=script&lang=js"
export * from "./CustomerProviders.vue?vue&type=script&lang=js"
import style0 from "./CustomerProviders.vue?vue&type=style&index=0&id=727151f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727151f6",
  null
  
)

export default component.exports